import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock } from '../Util'

// Window.sendKeys
defineStmtBlock(
  'sirenia_api_window_sendkeys',
  {
    message0: 'send keys %1 to window',
    args0: [
      {
        type: 'input_value',
        name: 'KEYS',
        check: 'String'
      }
    ],
    inputsInline: true,
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Simulates a user sending key strokes to the focused window',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#send-keys'
  },
  function(block) {
    var keys =
      Blockly.JavaScript.valueToCode(block, 'KEYS', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Window.sendKeys(${keys});\n`
  }
)

defineBlock(
  'sirenia_api_window_get_title',
  {
    message0: 'title of window',
    args0: [],
    tooltip: "Gets the title of the attached application's window",
    output: 'String',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#title'
  },
  function(block) {
    return [`Window.title()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_window_minimize',
  {
    message0: 'minimize window',
    args0: [],
    tooltip: "Minimizes the attached application's window",
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#minimize'
  },
  function(block) {
    return `Window.minimize();\n`
  }
)

defineBlock(
  'sirenia_api_window_is_minimized',
  {
    message0: 'window is minimized?',
    args0: [],
    tooltip: "Is the attached application's window minimized?",
    output: 'Boolean',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#is-minimized'
  },
  function(block) {
    return [`Window.isMinimized()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_window_maximize',
  {
    message0: 'maximize window',
    args0: [],
    tooltip: "Maximizes the attached application's window",
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#maximize'
  },
  function(block) {
    return `Window.maximize();\n`
  }
)

defineBlock(
  'sirenia_api_window_is_maximized',
  {
    message0: 'window is maximized?',
    args0: [],
    tooltip: "Is the attached application's window maximized?",
    output: 'Boolean',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#is-maximized'
  },
  function(block) {
    return [`Window.isMaximized()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_window_focus',
  {
    message0: 'focus window',
    args0: [],
    tooltip: "Focuses the attached application's window",
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#focus'
  },
  function(block) {
    return `Window.focus();\n`
  }
)

defineStmtBlock(
  'sirenia_api_window_restore',
  {
    message0: 'restore window',
    args0: [],
    tooltip: "Restores the attached application's window",
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#restore'
  },
  function(block) {
    return `Window.restore();\n`
  }
)

defineBlock(
  'sirenia_api_window_is_modal_shown',
  {
    message0: 'window is showing a modal?',
    args0: [],
    tooltip: "Is the attached application's window showing a modal window?",
    output: 'Boolean',
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#window-with-modal-dialog-shown'
  },
  function(block) {
    return [`Window.modalShown()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_window_is_title_shown',
  {
    message0: 'window is showing title %1?',
    args0: [
      {
        type: 'input_value',
        name: 'TITLE',
        check: 'String'
      }
    ],
    tooltip: "Is the attached application's window showing a window with this title?",
    output: 'Boolean',
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#shown-with-title'
  },
  function(block) {
    var title =
      Blockly.JavaScript.valueToCode(block, 'TITLE', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return [`Window.withTitleShown(${title})`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_window_dim',
  {
    message0: 'dim window by %1',
    args0: [
      {
        type: 'field_number',
        name: 'AMOUNT',
        value: 100,
        min: 0,
        max: 255
      }
    ],
    tooltip: "Restores the attached application's window",
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#restore'
  },
  function(block) {
    const dimAmount = block.getFieldValue('AMOUNT')
    return `Window.dim(${dimAmount});\n`
  }
)
